<template>
  <div
    v-if="isOpen && announcements.length"
    class="bg-green flex items-center font-medium h-40 max-sm:h-30"
  >
    <div class="container text-center text-body-sm max-sm:text-xs text-blue">
      <template v-if="announcements.length === 1">
        <component
          :is="announcements[0].url ? 'a' : 'div'"
          :href="announcements[0].url || null"
          class="block"
        
        >{{ announcements[0].text }}</component>
      </template>
      <CarouselKeen
        v-else
        :slides="1"
        :tablet_slides="1"
        :mobile_slides="1"
        :arrows="false"
        :progressbar="false"
        :loop="true"
        :autoplay="autoplay"
      >
        <div
          v-for="(item, idx) in announcements"
          :key="`ab-${idx}`"
          class="keen-slider__slide flex items-center justify-center"
        >
          <component
            :is="item.url ? 'a' : 'div'"
            :href="item.url || null"
            class="block w-full"
          
          >{{ item.text }}</component>
        </div>
      </CarouselKeen>
    </div>
  </div>
</template>

<script>
export default {
  name: "AnnouncementBar",
};
</script>

<script setup>
import {ref, computed} from "vue";

const props = defineProps({
  visible: {
    type: Boolean,
    required: false,
    default: true,
  },
  content: {
    type: String,
    required: false,
    default: "",
  },
  autoplay: {
    type: [Number, String],
    default: 5000,
  },
});

const isOpen = ref(props.visible);

const announcements = computed(() => {
  const fromGlobal =
    typeof window !== "undefined" && Array.isArray(window.Shopify?.announcement)
      ? window.Shopify.announcement.filter(a => a && a.text)
      : [];
  if (fromGlobal.length) return fromGlobal;
  return props.content ? [{text: props.content, url: ""}] : [];
});
</script>
